<template>
  <div class="subprogram-nba-player-card">

    <span
      v-text="i18n('entities.player.label')"
      class="subprogram-nba-player-card__title"
    ></span>

    <div class="subprogram-nba-player-card__table" v-loading="loading">
      <el-table
        v-if="players && players.length > 0"
        :data="players"
      >
        <!-- FirstName + LastName -->
        <el-table-column
          :label="i18n('entities.player.fields.name')"
        >
          <template slot-scope="scope">
            <div class="list__avatar" v-if="scope.row.picture.length>0" :style="{ backgroundImage: getPlayerAvatar(scope.row) }" />
            <span
              class="list__avatar__name"
              v-text="`${presenter(scope.row, 'firstName')} ${presenter(scope.row, 'lastName')}`"
            />
          </template>
        </el-table-column>

        <!-- Gender -->
        <el-table-column :label="i18n('entities.player.fields.gender')">
          <template slot-scope="scope">{{ presenter(scope.row, 'gender') }}</template>
        </el-table-column>

        <!-- Birthdate -->
        <el-table-column
          :label="i18n('entities.player.fields.birthdate')"
        >
          <template slot-scope="scope">{{ presenter(scope.row, 'birthdate') }}</template>
        </el-table-column>

        <!-- Teams -->
        <el-table-column
          :label="i18n('entities.player.fields.teams')"
          :width="280"
        >
          <template slot-scope="scope">
            <app-i18n v-if="!scope.row.teams || !scope.row.teams.length" code="common.none" />
            <span v-else-if="scope.row.teams.length === 1" v-text="scope.row.teams[0].name" />

            <el-tooltip
              v-else
              effect="dark"
              :content="scope.row.teams.map(team => team.name).join('\n')"
              placement="bottom"
            >
              <app-i18n code="entities.team.list.multipleTeams" />
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <app-empty-page
        v-else
        :icon-class="'icon-player'"
        :empty-text="i18n('entities.player.empty')"
      />

    </div>
  </div>
</template>

<script>
import { i18n } from '@shared/i18n';
import { mapGetters } from 'vuex';
import { PlayerModel } from '@modules/player/player-model';

export default {
  name: 'app-subprogram-nba-player-card',
  props: {
    players: {
      type: Array,
    },
  },

  computed: {
    ...mapGetters({
      loading: 'subprogram/nbaTeam/summary/loading',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),
    fields() {
      const { dateFormat, timeFormat} = this;
      return new PlayerModel({
        dateFormat,
        timeFormat
      }).fields();
    },
  },

  methods: {
    presenter(row, fieldName) {
      const { dateFormat, timeFormat } = this;
      return new PlayerModel({ dateFormat, timeFormat }).presenter(row, fieldName);
    },
    i18n(code) {
      return i18n(code);
    },
    getPlayerAvatar(row) {
      if (!('picture' in row)) return null;
      if (!(row.picture instanceof Array)) return null;
      if (!row.picture.length > 0) return null;
      if (!row.picture[0].publicUrl) return null;
      return `url("${row.picture[0].publicUrl}")`;
    },
  },
};
</script>

<style lang="scss" scoped>
.subprogram-nba-player-card {
  padding-top: 40px;
  &__title {
    font-size: 20px;
    color: #6c6c6c;
    text-transform: uppercase;
  }
  &__table {
    box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
    margin-top: 20px;
  }
}
</style>
